var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M400,710c169.28,0,310-140.72,310-310S568.98,90,399.7,90,90,230.41,90,400s140.41,310,310,310ZM282.38,565.94c-7.6,0-14.28-6.69-14.28-13.98v-258.03c0-13.07,6.38-22.79,18.84-28.26,10.94-4.86,20.36-7.6,43.76-7.6,55.01,0,89.35,27.05,141.02,27.05,24.92,0,37.99-6.38,45.89-6.38,10.33,0,18.24,6.38,18.24,15.2v149.83c0,13.68-5.77,22.49-18.84,28.26-11.25,5.17-20.97,7.9-43.77,7.9-52.88,0-86.62-26.74-141.02-26.74-18.54,0-30.7,3.65-36.17,6.08v92.7c0,7.6-5.77,13.98-13.68,13.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTime);
export default __webpack_public_path__ + "static/media/full-time.75b04e53.svg";
export { ForwardRef as ReactComponent };